export default {
  "--color-default": "rgb(255, 255, 255)",
  "--color-default-inverse": "rgb(12, 57, 68)",
  "--color-primary": "rgb(12, 57, 68)",
  "--color-primary-active": "rgb(12, 57, 68)",
  "--color-secondary": "rgb(193, 233, 78)",
  "--color-secondary-active": "rgb(193, 233, 78)",
  "--color-secondary-inverse": "rgb(0, 17, 35)",
  "--text-color-link": "rgb(12, 57, 68)",
  "--text-color-link-active": "rgb(12, 57, 68)",
  "--text-color-primary": "rgb(12, 57, 68)",
  "--text-color-secondary": "rgb(193, 233, 78)",
  "--text-color-secondary-inverse": "rgb(0, 17, 35)",
  "--background-color-primary": "rgb(12, 57, 68)",
  "--background-color-primary-active": "rgb(12, 57, 68)",
  "--background-color-secondary": "rgb(193, 233, 78)",
  "--background-color-secondary-active": "rgb(193, 233, 78)",
  "--background-color-secondary-inverse": "rgb(0, 17, 35)",
  "--border-color-soft": "rgb(224, 228, 235)",
  "--border-color-softer": "rgb(224, 228, 235)",
  "--border-color-active": "rgb(12, 57, 68)",
  "--border-color-primary": "rgb(12, 57, 68)",
  "--border-radius-l": "10px",
  "--font-heading": "Raleway, Helvetica, Arial, sans-serif",
  "--font-text": "Raleway, Helvetica, Arial, sans-serif"
};